const actions = {
  SET_STATE: 'languages/SET_STATE',
  FETCH_ALL: 'languages/FETCH_ALL',
  SELECT: 'languages/SELECT'
};

export default actions
